import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { getModuleData } from '../../api/auth';
import Navbar from '../../component/NavBar';
import Header from '../../component/Header';
import Spinner from '../../component/Spinner';

function ModuleMonitoring() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [moduleData, setModuleData] = useState([]);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mes");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            try {
                setIsShow(true);
                const result = await getModuleData();
                console.log('result', result);
                if (result.ok === true) {
                    setDate(result.date);
                    setModuleData(result.data);
                } else {
                    alert("API CALL FAIL");
                }
            } catch (error) {
                console.log('error', error);
                alert(error.message);
            } finally {
                setIsShow(false);
            }
        })();
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <Navbar />
            <div className='p-1 text-md'>
                <div className='font-bold'>
                    HMMA Sequence - <span className='uppercase'>{date}</span>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">

                                </th>
                                <th scope="col" className="py-1">
                                    SEQ
                                </th>
                                <th scope="col" className="py-1">
                                    TIME
                                </th>
                                <th scope="col" className="py-1">
                                    <a href="/mes/pbscts" target="_blank" className='underline font-bold text-blue-900'>CTS/PBS</a>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.toprow.map((v, i) => {
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b  `}>
                                            <td scope="row" className="bg-slate-300 py-1 font-medium text-gray-900 whitespace-nowrap ">
                                                {v.NAME}
                                            </td>
                                            <td className="py-1">
                                                {v.SEQ}
                                            </td>
                                            <td className="py-1">
                                                {v.TIME.substring(0, 2)}:{v.TIME.substring(2, 4)}:{v.TIME.substring(4, 6)}
                                            </td>
                                            <td className="py-1">
                                                {v.CTS}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    Production Status (Shift: {moduleData?.output?.toprow?.filter(v => v.SHIFT)?.map(v => v.SHIFT)?.[0]})
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">
                                    LINE
                                </th>
                                <th scope="col" className="py-1">
                                    Queue
                                </th>
                                <th scope="col" className="py-1">
                                    Output
                                </th>
                                <th scope="col" className="py-1">
                                    PF
                                </th>
                                <th scope="col" className="py-1">
                                    Target
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.row.filter(v => v.LINE !== "ASR").map((v, i) => {
                                    const PF = Number(v.PF);
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b  `}>
                                            <td scope="row" className={`bg-slate-300 py-1 font-medium text-gray-900 whitespace-nowrap `}
                                                style={{ width: '20%' }}>
                                                <span className={`${PF >= 99 ? 'text-green-500' : PF >= 95 ? 'text-yellow-300' : 'text-red-600'} font-extrabold`}>
                                                    O
                                                </span>
                                                <span> </span>{v.LINE}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.MITU}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.OUTPUT}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.PF}%
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                99
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    ASRS Status (Shift: {moduleData?.output?.toprow?.filter(v => v.SHIFT)?.map(v => v.SHIFT)?.[0]})
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    MX5
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    MX5H
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    NX4
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    OB
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>

                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.row.filter(v => v.LINE === "ASR").map((v, i) => {
                                    return (
                                        <tr key={i} className={`bg-gray-100 border-b  `}>
                                            <td scope="row" className={`py-1 whitespace-nowrap `}
                                                style={{ width: '20%' }}>
                                                {v.CNT_HZ}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.CNT_9B}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.CNT_HU}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.CNT_HP}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>

                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    JKE
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    JKI
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>

                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    SKID
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    EMPTY
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.row.filter(v => v.LINE === "ASR").map((v, i) => {
                                    return (
                                        <tr key={i} className={`bg-gray-100 border-b  `}>
                                            <td scope="row"
                                                className={`py-1 whitespace-nowrap `}
                                                style={{ width: '20%' }}>
                                                {v.CNT_9T}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.CNT_9Y}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>

                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.SKID_CNT}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.EMPTY_CNT}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    TOTAL
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    {moduleData?.output?.row.filter(v => v.LINE === "ASR").map((v) => {
                                        const MITU = Number(v.MITU);
                                        return (
                                            <span className={`${MITU >= -30 ? 'text-green-500' : MITU >= -50 ? 'text-yellow-300' : 'text-red-600'} font-extrabold`}>
                                                O
                                            </span>
                                        )
                                    })}
                                    QUE
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    {moduleData?.output?.row.filter(v => v.LINE === "ASR").map((v) => {
                                        const SO_T2 = Number(v.SO_T2);
                                        return (
                                            <span className={`${SO_T2 >= 1 ? 'text-green-500' : SO_T2 >= 0 ? 'text-yellow-300' : 'text-red-600'} font-extrabold`}>
                                                O
                                            </span>
                                        )
                                    })}
                                    GAP
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>
                                    SHTG
                                </th>
                                <th scope="col" className="py-1" style={{ width: '20%' }}>

                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.row.filter(v => v.LINE === "ASR").map((v, i) => {
                                    return (
                                        <tr key={i} className={`bg-gray-100 border-b  `}>
                                            <td scope="row" className={`py-1 whitespace-nowrap `}
                                                style={{ width: '20%' }}>
                                                {v.OUTPUT}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.MITU}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.SO_T2}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>
                                                {v.Shortage}
                                            </td>
                                            <td className="py-1" style={{ width: '20%' }}>

                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    Shipping Status (Shift: {moduleData?.output?.toprow?.filter(v => v.SHIFT)?.map(v => v.SHIFT)?.[0]})
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">
                                    LINE
                                </th>
                                <th scope="col" className="py-1">
                                    SO-T2
                                </th>
                                <th scope="col" className="py-1">
                                    Target
                                </th>
                                <th scope="col" className="py-1">
                                    Conv
                                </th>
                                <th scope="col" className="py-1">
                                    SO Seq
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.row.filter(v => v.LINE !== "ASR").map((v, i) => {
                                    const SO_T2 = Number(v.SO_T2);
                                    let warningColor;
                                    let warningTarget = '-';
                                    let convTail;
                                    if (v.LINE === "CPM") {
                                        warningColor = SO_T2 >= 35 ? 'text-green-500' : SO_T2 >= 10 ? 'text-yellow-300' : 'text-red-600';
                                        warningTarget = '35';
                                        convTail = '/32';
                                    } else if (v.LINE === "FCM") {
                                        warningColor = SO_T2 >= 30 ? 'text-green-500' : SO_T2 >= 0 ? 'text-yellow-300' : 'text-red-600';
                                        warningTarget = '30';
                                        convTail = '/36';
                                    } else if (v.LINE === "RCM") {
                                        warningColor = SO_T2 >= 30 ? 'text-green-500' : SO_T2 >= 0 ? 'text-yellow-300' : 'text-red-600';
                                        warningTarget = '30';
                                        convTail = '/42';
                                    }
                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b  `}>
                                            <th scope="row" className={`py-1 font-medium text-gray-900 whitespace-nowrap bg-slate-300`}>
                                                <span className={`${warningColor} font-extrabold`}>
                                                    O
                                                </span>
                                                <span> </span>{v.LINE}
                                            </th>
                                            <td className="py-1">
                                                {v.SO_T2}
                                            </td>
                                            <td className="py-1">
                                                {warningTarget}
                                            </td>
                                            <td className="py-1">
                                                {v.CONV}{convTail}
                                            </td>
                                            <td className="py-1">
                                                {v.SOSEQ}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    <a href="/mes/rtms" target="_blank" className='underline font-bold text-blue-900'>RTMS & HMMA Stock</a>
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">
                                    LINE
                                </th>
                                <th scope="col" className="py-1">
                                    RTMS
                                </th>
                                <th scope="col" className="py-1">
                                    HMMA
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                moduleData?.output?.row.filter(v => v.LINE !== "ASR").map((v, i) => {
                                    const HMMACnt = Number(v.HMMACnt);
                                    const total = Number(v.InTranCnt.substring(0, v.InTranCnt.indexOf('-'))) + Number(v.HMMACnt);

                                    return (
                                        <tr key={i} className={`${i % 2 === 0 ? 'bg-white' : 'bg-gray-100'} border-b  `}>
                                            <th scope="row" className={`py-1 font-medium text-gray-900 whitespace-nowrap bg-slate-300`}>
                                                <span className={`${HMMACnt >= 37 ? 'text-green-500' : total >= 37 ? 'text-yellow-300' : 'text-red-600'} font-extrabold`}>
                                                    O
                                                </span>
                                                <span> </span>{v.LINE}
                                            </th>
                                            <td className="py-1">
                                                {v.InTranCnt}
                                            </td>
                                            <td className="py-1">
                                                {v.HMMACnt}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    Error Message: {moduleData?.output?.ERRMSG}
                </div>
            </div>
        </>
    )
}

export default ModuleMonitoring;
